/**
 * Call Stage Colors
 * A centralized set of color constants for candidate call stages
 */

export const CALL_STAGE_COLORS = {
  "New Profile": "#657ba7", // Neutral Gray
  "Not Spoken - VM / NR - Emailed": "#9CA3AF", // Light Gray / Muted
  "Spoken - To Track": "#3B82F6", // Light Blue (Info)
  "Not Suitable": "#F87171", // Light Red (Error)
  "Not Interested": "#fb6363ff", // Light Red (Error)
  "Interested": "#34D399", // Soft Green (Positive)
  "Proposed": "#8B5CF6", // Light Purple (Progress)
  "Shortlisted": "#2563EB", // Darker Blue (Strong Progress)
  "Interview Scheduled": "#6366F1", // Deep Indigo (Important)
  "Interview Reject": "#EF4444", // Bright Red (Error)
  "Offered": "#10B981", // Bright Green (Success)
  "Offer Rejected - Client": "#DC2626", // Dark Red
  "Offer Declined - Candidate": "#DC2626", // Dark Red
  "Joined": "#059669", // Emerald Green (Success)
  "Joined - Client Reject": "#F97316", // Orange (Warning)
  "Project End": "#FACC15", // Muted Yellow (Closure)
  "Fake": "#B91C1C", // Deep Red (Alert)
  "Withdrawn": "#ba1010", // Darker Red (Withdrawing)
};

/**
 * Get the color for a call stage
 * @param {string} stage - The call stage name
 * @returns {string} The corresponding color code
 */
export const getStageColor = (stage) => {
  return CALL_STAGE_COLORS[stage] || "#6B7280"; // Default to Neutral Gray
};

export default CALL_STAGE_COLORS; 